import { getAuthWithAppName } from "../../auth/index";
import { API_PDC_URL_V1 } from "../../../../config";
import { getRestCall } from "../../../services/rest-api-call";

export const readConstants = {
  GET_NOTIFICATION_LIST_START: "GET_NOTIFICATION_LIST_START",
  GET_NOTIFICATION_LIST_ERROR: "GET_NOTIFICATION_LIST_ERROR",
  GET_NOTIFICATION_LIST_SUCCESS: "GET_NOTIFICATION_LIST_SUCCESS"
};

export function getNotificationsList(auth, ncsId) {
  return async(dispatch, getState) => {
    dispatch({
      type: readConstants.GET_NOTIFICATION_LIST_START,
      payload: { ncsId }
    });

    const requestUrl = `${API_PDC_URL_V1}/notifications/${ncsId}/web`;
    const authObj = getAuthWithAppName(auth);

    try {
      const response = await getRestCall(
        requestUrl, authObj, null, dispatch, authObj.refreshToken, false, undefined, false
      );

      dispatch({
        type: readConstants.GET_NOTIFICATION_LIST_SUCCESS,
        payload: {
          ...response
        }
      });
    } catch (e) {
      dispatch({
        type: readConstants.GET_NOTIFICATION_LIST_ERROR,
        error: e,
        payload: { ncsId }
      });
    }
  };
}
